/* eslint-disable class-methods-use-this */
import { Form, Formik } from "formik";
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compareByNome } from "utils/orderHelper";
import Button from "../../../components/Button/button.component";
import WidgetDialog from "../../../components/Dialog/dialog.component";
import Input from "../../../components/Input/input.component";
import InputText from "../../../components/Input/inputText.component";
import InputTime from "../../../components/Input/inputTime.style";
import Required from "../../../components/Required/required.component";
import SelectMulti from "../../../components/SelectMulti/selectmulti.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import Title from "../../../components/Title/title.component";
import SelectService from "../../../services/comumService";
import DadosService from "../../../services/dadosParametrizados";
import { DADOS_PARAMETRIZADOS_MODEL } from "../../../utils/models";
import ToastHelper from "../../../utils/toastHelper";

class CadastroDadosParametrizados extends Component {
	state = {
		isOpenDialog: false,
		isOpenDialogCancelar: false,

		orgaos: [],
		categorias: [],
		severidades: [],
		urgencias: [],
		confiancas: [],
		orgaoSelecionado: undefined,
		categoriaSelecionada: undefined,
		severidadeSelecionada: undefined,
		urgenciaSelecionada: undefined,
		confiancaSelecionada: undefined,
		isDirty: false,
		dadoParametrizado: DADOS_PARAMETRIZADOS_MODEL,
		loading: false
	};

	async componentDidMount() {
		const { alertaId } = this.props;
		let responses = {};
		let {
			responseAlerta,
			responseOrgaos,
			responseCategorias,
			responseSeveridades,
			responseUrgencias,
			responseConfiancas
		} = responses;

		const promises = [];

		promises.push(
			DadosService.findAlertaById(alertaId).then(
				response => (responseAlerta = response)
			)
		);

		promises.push(
			SelectService.findAllOrgaos().then(
				response => (responseOrgaos = response)
			)
		);

		promises.push(
			SelectService.findAllCategorias().then(
				response => (responseCategorias = response)
			)
		);

		promises.push(
			SelectService.findAllSeveridades().then(
				response => (responseSeveridades = response)
			)
		);

		promises.push(
			SelectService.findAllUrgencias().then(
				response => (responseUrgencias = response)
			)
		);

		promises.push(
			SelectService.findAllConfiancas().then(
				response => (responseConfiancas = response)
			)
		);

		this.setLoading(true);
		Promise.all(promises)
			.then(() => {
				this.setState({
					dadoParametrizado: {
						...responseAlerta
					},
					orgaos: [...responseOrgaos.data],
					categorias: [...responseCategorias.data],
					severidades: [...responseSeveridades.data],
					urgencias: [...responseUrgencias.data],
					confiancas: [...responseConfiancas.data],
					loading: false
				});
			})
			.catch(() => {
				this.setLoading(false);
			});
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	componentWillUnmount() {
		this.handleSubmit();
	}

	/* HANDLE CHANGE SELECTS */
	onChangeSelect(item, entidadeSelecionada, entidade) {
		const newState = this.state;
		newState[entidadeSelecionada] = item.object;
		newState.dadoParametrizado[entidade] = item.object;
		newState.isDirty = true;
		this.setState(newState);
	}

	/* HANDLE CHANGE INPUTS NORMAIS */
	handleInputChange = event => {
		const { dadoParametrizado } = this.state;
		const { target } = event;
		const { name } = target;

		this.setState({
			isDirty: true,
			dadoParametrizado: {
				...dadoParametrizado,
				[name]: target.value
			}
		});
	};

	handleSubmit = async () => {
		const {
			state: { dadoParametrizado, isDirty },
			props: { alertaId }
		} = this;
		if (isDirty) {
			try {
				this.setLoading(true);
				await DadosService.saveDadosParametrizados(
					dadoParametrizado,
					async () => {
						await DadosService.findAlertaById(alertaId);
						this.setLoading(false);
					}
				);
				ToastHelper.success("Dados parametrizados salvos com sucesso!");
			} catch (error) {
				ToastHelper.warn(error.response.data.message);
			}
		}
	};

	checkDataValue = data => {
		const dataMax = this.getDataMax();
		if (data > dataMax) {
			return dataMax;
		}
		return data;
	};

	/*
		MODAIS CANCELAR
	*/

	handleCancelar = () => {
		this.setState({ isOpenDialogCancelar: true, isDirty: false });
	};

	handleDialogCancelar = ({ isOpenDialogCancelar }, { history }) => (
		<WidgetDialog
			title="Atenção!"
			isOpen={isOpenDialogCancelar}
			textCancelar="Não"
			textConfirmar="Sim"
			mensagem="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos"
			cancelar={() => {
				this.setState({ isOpenDialogCancelar: false });
			}}
			confirmar={() => {
				this.setState({ isOpenDialogCancelar: false });
				history.push("/alertas");
			}}
		/>
	);

	handleDialog = ({ isOpenDialog }) => (
		<WidgetDialog
			isOpen={isOpenDialog}
			confirmar={() => this.setState({ isOpenDialog: false })}
		/>
	);

	getDataMax = () => {
		const dataAtual = new Date();
		let dia = dataAtual.getDate();
		let mes = dataAtual.getMonth() + 1;
		const ano = dataAtual.getFullYear();

		if (mes <= 9) {
			mes = `0${mes}`;
		}
		if (dia <= 9) {
			dia = `0${dia}`;
		}

		return `${ano}-${mes}-${dia}`;
	};

	/* Ordena as origens pelo ID */
	orderCategorias(categorias) {
		categorias.sort(compareByNome);
		return categorias;
	}

	render() {
		const {
			state: {
				categorias,
				severidades,
				orgaos,
				urgencias,
				confiancas,
				dadoParametrizado,
				orgaoSelecionado,
				categoriaSelecionada,
				severidadeSelecionada,
				urgenciaSelecionada,
				confiancaSelecionada
			},
			props: { onClick }
		} = this;

		return (
			<div>
				<div>
					{this.state.loading && (
						<LoadingStyle className="loading">
							<div className="text-center">
								<div className="spinner-border" role="status" />
							</div>
						</LoadingStyle>
					)}
					<Title>Dados parametrizados do possível alerta</Title>
					<hr />
					<Formik
						initialValues={dadoParametrizado}
						enableReinitialize
						onSubmit={this.handleSubmit}
						render={({ values }) => (
							<Form>
								<div className="ml-1 mr-1">
									<div className="row">
										<div className="col-md-6">
											<label>
												Origem da informação:{" "}
												<Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="iniciador"
													label="nome"
													value={
														orgaoSelecionado ||
														values.iniciador
													}
													onChange={item => {
														this.onChangeSelect(
															item,
															"orgaoSelecionado",
															"iniciador"
														);
													}}
													options={orgaos}
												/>
											</div>
										</div>

										<div className="col-md-3">
											<label>
												Data da informação: <Required />
											</label>
											<InputText
												type="date"
												name="dataOcorrencia"
												max={this.getDataMax()}
												checkDate={this.checkDataValue}
												onChange={
													this.handleInputChange
												}
												value={
													values.dataOcorrencia || ""
												}
											/>
										</div>

										<div className="col-md-3">
											<label>
												Hora da informação: <Required />
											</label>
											<div className="form-group">
												<InputText
													type="time"
													onChange={
														this.handleInputChange
													}
													value={
														values.horaOcorrencia ||
														""
													}
													name="horaOcorrencia"
												/>
											</div>
										</div>
									</div>

									<Subtitle>Evento</Subtitle>
									<hr />
									<div className="row">
										<div className="col-md-6">
											<label>
												Categoria do evento:{" "}
												<Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="categoria"
													label="nome"
													value={
														categoriaSelecionada ||
														values.categoria
													}
													onChange={item => {
														this.onChangeSelect(
															item,
															"categoriaSelecionada",
															"categoria"
														);
													}}
													options={this.orderCategorias(
														categorias
													)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<label>
												Severidade do evento:{" "}
												<Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="severidade"
													label="nome"
													value={
														severidadeSelecionada ||
														values.severidade
													}
													onChange={item => {
														this.onChangeSelect(
															item,
															"severidadeSelecionada",
															"severidade"
														);
													}}
													options={severidades}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<label>
												Urgência: <Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="iniciador"
													label="nome"
													value={
														urgenciaSelecionada ||
														values.urgencia
													}
													onChange={item => {
														this.onChangeSelect(
															item,
															"urgenciaSelecionada",
															"urgencia"
														);
													}}
													options={urgencias}
												/>
											</div>
										</div>
										<div className="col-md-3">
											<label>
												Confiança: <Required />
											</label>
											<div className="form-group">
												<SelectMulti
													isClearable={false}
													isMulti={false}
													name="confianca"
													label="nome"
													value={
														confiancaSelecionada ||
														values.confianca
													}
													onChange={item => {
														this.onChangeSelect(
															item,
															"confiancaSelecionada",
															"confianca"
														);
													}}
													options={confiancas}
												/>
											</div>
										</div>

										<div className="col-md-3">
											<label>
												Duração do evento (em horas):{" "}
												<Required />
											</label>
											<div className="form-group">
												<Input
													min={0}
													onChange={event => {
														// eslint-disable-next-line
														const regex = /^([0-9]+(?:[\,][0-9]*)?|\,[0-9]+)*$/;
														if (
															regex.test(
																event.target
																	.value
															)
														) {
															this.handleInputChange(
																event
															);
														}
													}}
													value={values.periodo || ""}
													name="periodo"
													style={InputTime.getTimeStyle()}
												/>
											</div>
										</div>
									</div>

									<Subtitle>Informações</Subtitle>
									<hr />
									<div className="row">
										<div className="col-md-6">
											<label>
												Danos possíveis: <Required />
											</label>
											<div className="form-group">
												<InputText
													type="textarea"
													name="danosPossiveis"
													onChange={
														this.handleInputChange
													}
													value={
														values.danosPossiveis ||
														""
													}
													maxLength="255"
												/>
											</div>
										</div>

										<div className="col-md-6">
											<label>
												Recomendações de segurança:{" "}
												<Required />
											</label>
											<div className="form-group">
												<InputText
													type="textarea"
													name="planoContigencia"
													onChange={
														this.handleInputChange
													}
													value={
														values.planoContigencia ||
														""
													}
													maxLength="255"
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<label>
												Informações recebidas da origem:{" "}
												<Required />
											</label>
											<div className="form-group">
												<InputText
													type="textarea"
													name="informacoes"
													onChange={
														this.handleInputChange
													}
													value={
														values.informacoes || ""
													}
													maxLength="255"
												/>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-6">
											<div className="row">
												<div className="col-md-12">
													<div className="float-left ">
														<Button
															type="button"
															cancel
															text="Cancelar"
															icon="fas fa-times"
															onClick={() =>
																this.handleCancelar()
															}
														/>
													</div>
												</div>
											</div>
										</div>

										<div className="col-6">
											<div className="row">
												<div className="col-md-12">
													<div className="float-right">
														<Button
															type="submit"
															primary
															text="Salvar"
															icon="fas fa-save"
														/>

														<Button
															onClick={() =>
																onClick("geo")
															}
															type="submit"
															primary
															text="Próximo"
															icon="fas fa-arrow-right"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Form>
						)}
					/>
				</div>
				{this.handleDialog(this.state)}
				{this.handleDialogCancelar(this.state, this.props)}
			</div>
		);
	}
}
export default withRouter(CadastroDadosParametrizados);
